export function parseImageUrl(url, width, height) {
    if (url) {
        return url.replace('{width}', width).replace('{height}', height);
    }

    return false;
}
